import { FormioFormConfig } from './form-io';
import { UserProvider } from './provider';
import { SdohReferralStatusReason, SdohReferralStatusReasonLabelMap } from './sdoh-status-reason.model';
import { SdohReferralStatusLabelMap } from './sdoh-status.model';
import { SdohSubmissionStatusLabelMap, SdohSubmissionType } from './sdoh-submission.model';


export interface SubmissionData {
  access: string[];
  created: Date | string;
  data: any;
  externalIds: string[];
  form: string;
  formId: string;
  formRevision: number;
  modified: Date | string;
  owner: string;
  project: string;
  roles: string[];
  state: string;
  _fvid: number;
  _id: string;
  _vid: number;
}


export enum TabsType {
  PendingReferrals,
  MyReferrals,
  AllReferrals,
  Archived
}

export enum SdohReferralCardTabs {
  ActionPlan,
  Assessment,
  Visits,
  Referral
}

export interface FormConfig {
  form: FormioFormConfig;
  formSubmissionId: string;
  submission: SubmissionData;
}

export enum PendingReferralStatusesSearch {
  AllReferrals = 'All Referrals',
  PendingReferral = 'Pending Referral Acceptance',
  PendingClinician = 'Pending Clinician Assignment',
  None = 'None'
}

export const AllStatusesLabelMap: { [key: string]: string } = {
  AllReferrals: 'All Referrals',
  None: 'None',
  ...SdohReferralStatusLabelMap,
  ...SdohReferralStatusReasonLabelMap,
  ...SdohSubmissionStatusLabelMap
};

export const SdohStatusList = [
  SdohReferralStatusReason.PendingFV,
  SdohReferralStatusReason.PendingFVForm,
  SdohReferralStatusReason.FVReview,
  SdohReferralStatusReason.PendingSV,
  SdohReferralStatusReason.PendingSVForm,
  SdohReferralStatusReason.SVReview,
  SdohReferralStatusReason.PendingWithdrawal
];


export interface SubmissionFormData {
  form: FormioFormConfig;
  formSubmissionId: string;
  submission: SubmissionData;
}

// Action Plan
export interface APMemberDataModel {
  dateOfBirth: Date | string;
  firstName: string;
  lastName: string;
  subscriberNumber: string;
  form: FormioFormConfig;
}

// Assessment
export interface ASMemberDataModel {
  addressLine: string;
  age: number;
  city: string;
  dateOfBirth: Date | string;
  firstName: string;
  lastName: string;
  providerName: string;
  phoneNumber: string;
  state: string;
  zipCode: string;
  subscriberNumber: string;
  form: FormioFormConfig;
}

export interface SearchFormAssessmentsData {
  members?: string | null;
  measure: string | null;
  status: string | null;
  dueDateTime: (Date | string)[] | null;
  subscriberNumber: string | null;
  referenceNumber: string | null;
  referralStatusReason: string | null;
  provider: ServiceProvider[] | null;
  userName: string | null;
  state: string | null;
  formStatus?: string | null;
}

export interface SearchFormReferralsData {
  status: string | null;
  referralStatusReason: string | null;
  subscriberNumber: string | null;
  referenceNumber: string | null;
  userName?: string | null;
}

export interface SubmissionUpdateModel {
  referralSubmissionId: string;
  tenantId: string;
  formType: SdohSubmissionType;
  formId: string;
  formRevision: number;
  formDataJson: any;
}

export interface AssessmentData {
  referralSubmissionId: string | number;
  tenantId: string | number;
  referralId: string | number;
}

export interface RelevantSearchData {
  measure: string[];
  statuses: string[];
  statusReasons: string[];
  serviceProviders: ServiceProvider[];
  providers: UserProvider[];
}

export interface ServiceProvider {
  npi: string | null;
  providerName: string;
  providerAccountId: string;
  value?: string;
  label?: string;
}

export class States {
  state?: string;
}
